import React from 'react';
import { TAnnotatedDataPoint, TInscriptionGraphic } from '@@config/report';
import { renderInscriptionWithImages } from '@@utils/utils';

type TInscriptionRowProps = {
    tableItemKey: string;
    tableItemData: TAnnotatedDataPoint;
    graphics?: TInscriptionGraphic[];
};

const InscriptionRow: React.FC<TInscriptionRowProps> = ({
    tableItemKey,
    tableItemData,
    graphics = [],
}): React.JSX.Element => {
    const { VALUE: inscription } = tableItemData;

    return (
        <tr className='inscription-row' key={tableItemKey}>
            <td colSpan={2}>{renderInscriptionWithImages(inscription, graphics, tableItemKey)}</td>
        </tr>
    );
};

export default InscriptionRow;
